import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LogOut03 = function LogOut03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m16 16.9999 5-5m0 0-5-5m5 5H9m3 5c0 .2956 0 .4434-.011.5714a3 3 0 0 1-2.404 2.6859c-.126.0251-.273.0414-.5667.074l-1.0214.1135c-1.5344.1705-2.3017.2558-2.9112.0607a3 3 0 0 1-1.8245-1.633C3 18.2881 3 17.5162 3 15.9722V8.0276c0-1.5439 0-2.3159.2612-2.9001a3 3 0 0 1 1.8245-1.633c.6095-.195 1.3768-.1098 2.9112.0607l1.0214.1134c.2938.0327.4407.049.5667.074a3 3 0 0 1 2.404 2.686c.011.128.011.2758.011.5713"
    })
  }));
};
export default LogOut03;